import { DeliveredDetailsImage } from "../vehicle-delivered/CardDeliveredDetails/DeliveredDetails.Image";

type VehiclesHistoricalRowProps = {
  name: string
  initialData: { type: string, content: string, }
  prefix: string
  vehicleId: string

}
export function DetailsImageVehicleRow(props: VehiclesHistoricalRowProps) {
  return (
    <div className="flex flex-col items-center gap-2">
      <span className="text-xs font-semibold text-black">
        {props.initialData?.type || "Sem tipo"}
      </span>
      <DeliveredDetailsImage src={props.initialData?.content || ""} />
    </div>
  )
}
